"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fonts = void 0;
const utils_1 = require("@icr-ui/utils");
const spacings_1 = __importDefault(require("./spacings"));
exports.fonts = {
    highlight: {
        lg: {
            fontWeight: 600,
            fontSize: spacings_1.default.s9,
            lineHeight: spacings_1.default.s10,
        },
        md: {
            fontWeight: 600,
            fontSize: spacings_1.default.s8,
            lineHeight: spacings_1.default.s9,
        },
        sm: {
            fontWeight: 600,
            fontSize: (0, utils_1.pxToRem)(36),
            lineHeight: (0, utils_1.pxToRem)(44),
        },
    },
    heading: {
        h1: {
            fontWeight: 600,
            fontSize: spacings_1.default.s6,
            lineHeight: spacings_1.default.s7,
        },
        h2: {
            fontWeight: 600,
            fontSize: spacings_1.default.s5,
            lineHeight: (0, utils_1.pxToRem)(28),
        },
        h3: {
            fontWeight: 600,
            fontSize: (0, utils_1.pxToRem)(18),
            lineHeight: (0, utils_1.pxToRem)(26),
        },
        h4: {
            fontWeight: 600,
            fontSize: spacings_1.default.s4,
            lineHeight: spacings_1.default.s6,
        },
        h5: {
            fontWeight: 600,
            fontSize: (0, utils_1.pxToRem)(14),
            lineHeight: spacings_1.default.s5,
        },
        h6: {
            fontWeight: 600,
            fontSize: spacings_1.default.s3,
            lineHeight: (0, utils_1.pxToRem)(18),
        },
    },
    body: {
        lead: {
            fontSize: (0, utils_1.pxToRem)(18),
            lineHeight: (0, utils_1.pxToRem)(26),
        },
        normal: {
            fontSize: spacings_1.default.s4,
            lineHeight: spacings_1.default.s6,
        },
        small: {
            fontSize: (0, utils_1.pxToRem)(14),
            lineHeight: spacings_1.default.s5,
        },
        tiny: {
            fontSize: spacings_1.default.s3,
            lineHeight: (0, utils_1.pxToRem)(18),
        },
        weights: {
            light: 300,
            medium: 500,
        },
    },
    button: {
        small: {
            fontWeight: 700,
            fontSize: spacings_1.default.s3,
            lineHeight: (0, utils_1.pxToRem)(18),
        },
        normal: {
            fontWeight: 700,
            fontSize: (0, utils_1.pxToRem)(14),
            lineHeight: spacings_1.default.s5,
        },
        large: {
            fontWeight: 600,
            fontSize: spacings_1.default.s8,
            lineHeight: spacings_1.default.s9,
        },
    },
    defaultFontFamily: "https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');",
};
exports.default = exports.fonts;
//# sourceMappingURL=fonts.js.map